import "./loading.css";

const Loading = ({ type }) => {
  return (
    <div className="loader-box">
      {type === "type-1" ? <span className="loader-1"></span> : <span className="loader-2"></span>}
    </div>
  );
};

export default Loading;
